import { fdsAxios } from 'util/Api';

import {
  SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  FETCH_FDS_CARDS_START,
  FETCH_FDS_CARDS_ERROR,
  FETCH_FDS_CARDS_SUCCESS,
  ADD_FDS_CARD_ERROR,
  ADD_FDS_CARD_START,
  ADD_FDS_CARD_SUCCESS,
  UPDATE_FDS_CARD_START,
  UPDATE_FDS_CARD_SUCCESS,
  UPDATE_FDS_CARD_ERROR,
} from '../../constants/ActionTypes';

export const getFdsCards = (params) => (dispatch) => {
  dispatch({ type: FETCH_FDS_CARDS_START });
  fdsAxios.get(`cards${params ? `?${params}` : ''}`).then(({ data, headers }) => {
    dispatch({
      type: FETCH_FDS_CARDS_SUCCESS,
      payload: data.data,
      meta: {
        page: Number(headers['content-range'].split('-')[0]),
        pageTotal: Number(headers['content-range'].split('/')[1]),
      },
    });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_FDS_CARDS_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const addFdsCard = (fdsCard) => (dispatch) => {
  dispatch({ type: ADD_FDS_CARD_START });
  fdsAxios.post('/cards', fdsCard).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response.data && response.data.name !== 'MongoError') {
      dispatch({ type: ADD_FDS_CARD_SUCCESS, payload: response.data });
      dispatch({ type: SHOW_MESSAGE, payload: `Added fds card: ${response.data.name}` });
    } else {
      dispatch({ type: ADD_FDS_CARD_ERROR, payload: response.data.name });
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble adding this" });
      console.error('Error: ', response.data.name);
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: ADD_FDS_CARD_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const updateFdsCard = (fdsCardId, values) => (dispatch) => {
  dispatch({ type: UPDATE_FDS_CARD_START });
  fdsAxios.put(`/cards/${fdsCardId}`, values).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: UPDATE_FDS_CARD_SUCCESS, payload: response.data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Succesfully updated fds card' });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble updating this" });
    }
    dispatch({ type: UPDATE_FDS_CARD_ERROR });
    console.error('Error: ', error.message);
  });
};
